//React
import { FunctionComponent, useEffect, useState } from "react";
import { useAppSelector } from "../../redux/hooks/redux-store-hooks";
import { selectIsMobile } from "../../redux/selectors/select-is-mobile";
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { selectOwningTeam } from "../../../area-info/redux/selectors/select-owning-team";
import { selectAreaIsCity } from "../../../area-info/redux/selectors/select-area-is-city";

const RfiButton: FunctionComponent = () => {
	const owningTeam = useAppSelector(selectOwningTeam);
	const isMobile = useAppSelector(selectIsMobile);
	const areaIsCity = useAppSelector(selectAreaIsCity);

	function checkRfiButton(): boolean {
		//Only show the rfi button on city pages
		if (!areaIsCity) {
			return false;
		}

		//If there is no owning team then do not show the button
		if (isStringEmpty(owningTeam)) {
			return false;
		}

		return true;
	}

	const [showRfiButton, setShowRfiButton] = useState<boolean>(false);

	useEffect(() => {
		setShowRfiButton(checkRfiButton());
	}, [areaIsCity, owningTeam]);

	return (
		<>
			<div
				className="rfi-btn-mobile-back"
				style={{ display: showRfiButton && isMobile ? "block" : "none" }}
			></div>
			<button
				className="rfi-btn btn"
				id="rfi-btn"
				role="button"
				tabIndex={0}
				style={{ visibility: showRfiButton ? "visible" : "hidden" }}
			>
				{isMobile ? "Get Info" : "Get information"}
			</button>
		</>
	);
};

export default RfiButton;
